import { DialogConfig } from '@angular/cdk/dialog';

export const DEFAULT_DIALOG_OPTIONS: DialogConfig = {
  hasBackdrop: true,
  backdropClass: ['bg-black', 'bg-opacity-50'],
  panelClass: ['app-custom-panel'],
};

export const DEFAULT_SIDE_PANEL_OPTIONS: DialogConfig = {
  hasBackdrop: true,
  backdropClass: ['bg-black', 'bg-opacity-50'],
  panelClass: [
    'app-side-panel',
    'animate__animated',
    'animate__slideInRight',
    'animate__faster',
    'relative',
    'md:min-w-[48rem]',
    'max-md:w-[95svw]',
    'h-svh',
  ],
};

export const DEFAULT_PREVIEW_OPTIONS: DialogConfig = {
  hasBackdrop: false,
  panelClass: ['contents', 'w-svw'],
};
